import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getFocusAreaQueryDocument } from "./focus-area.gql";

export interface UseGetFocusAreaProps {
  id?: string;
  enabled?: boolean;
}

export const useGetFocusArea = ({ id, enabled = true }: UseGetFocusAreaProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.focusAreas.detail(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Focus Area ID is required");
      }
      const client = createOperationClient("GetFocusArea");
      const data = await client.request(getFocusAreaQueryDocument, { input: { id } });
      return data.focusArea;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  const focusArea = useMemo(() => {
    return queryResult.data ?? null;
  }, [queryResult.data]);

  return {
    focusArea,
    loading: queryResult.isLoading,
    error: queryResult.error,
    queryResult,
  };
};
